import React from "react";
import { useTranslation } from "react-i18next";
import { BlockTry } from "../../blocks/common-blocktry";
import { CommonConsult } from "../../blocks/common-consult";
import { CustomerBanner } from "../../blocks/customer-banner";
import { CustomerCompany } from "../../blocks/customer-company";
import { CustomerHot } from "../../blocks/customer-hot";
import { CustomerList } from "../../blocks/customer-list";
import { CustomerStorys } from "../../blocks/customer-storys";
import { HomeTryOn } from "../../blocks/home-try-on";
import { MainComment } from "../../blocks/main-comment";
import { MainLogo } from "../../blocks/main-logo";
import { SolutionCustomer } from "../../blocks/solution-customer";
import { Button } from "../../components/Button";
import { Footer } from "../../components/Footer";

import { Header } from "../../components/Header";

import "./styles.less";

export const CustomerPage = () => {
  const { t } = useTranslation();
  return (
    <div className="customer-page">
      <Header mode={"dark"} />
      <CustomerBanner />
      {/* <CustomerList /> */}
      <CustomerHot />
      <MainComment />
      <CustomerCompany />
      <SolutionCustomer />
      <HomeTryOn />
      <Footer />
    </div>
  );
};
